var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 2H3.63462C2.73184 2 2 2.73184 2 3.63462V14.75C2 15.6528 2.73184 16.3846 3.63462 16.3846H14.75C15.6528 16.3846 16.3846 15.6528 16.3846 14.75V3.63462C16.3846 2.73184 15.6528 2 14.75 2Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3654 2H23.25C22.3472 2 21.6154 2.73184 21.6154 3.63462V14.75C21.6154 15.6528 22.3472 16.3846 23.25 16.3846H34.3654C35.2681 16.3846 36 15.6528 36 14.75V3.63462C36 2.73184 35.2681 2 34.3654 2Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 21.6155H3.63462C2.73184 21.6155 2 22.3473 2 23.2501V34.3655C2 35.2683 2.73184 36.0001 3.63462 36.0001H14.75C15.6528 36.0001 16.3846 35.2683 16.3846 34.3655V23.2501C16.3846 22.3473 15.6528 21.6155 14.75 21.6155Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3654 21.6155H23.25C22.3472 21.6155 21.6154 22.3473 21.6154 23.2501V34.3655C21.6154 35.2683 22.3472 36.0001 23.25 36.0001H34.3654C35.2681 36.0001 36 35.2683 36 34.3655V23.2501C36 22.3473 35.2681 21.6155 34.3654 21.6155Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.5ff65f3fb6ec64ca4e06502426eb5bd6.svg";
export { ForwardRef as ReactComponent };